import { render, staticRenderFns } from "./plant.vue?vue&type=template&id=fa6e46d4&scoped=true&"
import script from "./plant.vue?vue&type=script&lang=js&"
export * from "./plant.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentStepTwoForms.styles.scss?vue&type=style&index=0&id=fa6e46d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6e46d4",
  null
  
)

export default component.exports